import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * @description Renderiza os controles de navegação de página (anterior, contador, próxima).
 * @param {object} props
 * @param {number} props.currentPage - A página atualmente ativa.
 * @param {number} props.totalPages - O número total de páginas.
 * @param {function} props.onPageChange - Função chamada quando o usuário clica para mudar de página.
 */
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    // Não renderiza o componente se houver apenas uma página ou nenhuma.
    if (totalPages <= 1) {
        return null;
    }

    return (
        <div className="flex items-center justify-center gap-4 mt-8">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="p-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed transition-colors bg-white dark:bg-slate-700 hover:bg-slate-100 dark:hover:bg-slate-600 shadow-sm border border-slate-200 dark:border-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900"
                aria-label="Página anterior"
            >
                <ChevronLeft size={20} />
            </button>
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">
                Página {currentPage} de {totalPages}
            </span>
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="p-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed transition-colors bg-white dark:bg-slate-700 hover:bg-slate-100 dark:hover:bg-slate-600 shadow-sm border border-slate-200 dark:border-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900"
                aria-label="Próxima página"
            >
                <ChevronRight size={20} />
            </button>
        </div>
    );
};

// ⚡ Bolt: Wrapped in React.memo() to prevent unnecessary re-renders when parent page states update
// (e.g., search inputs, active tabs) but the pagination props haven't changed.
export default React.memo(Pagination);
